export const InstallationReportTab = {
  ORDER_OVERVIEW: 'ORDER_OVERVIEW',
  PLOT_DESIGN: 'PLOT_DESIGN',
  PRE_INSTALLATION: 'PRE_INSTALLATION',
  PLOT_EXCAVATION: 'PLOT_EXCAVATION',
  DUCT_CONNECTING: 'DUCT_CONNECTING',
  CABLE_BLOWING: 'CABLE_BLOWING',
  SPLICING_MEASURING: 'SPLICING_MEASURING',
  COMMISSION: 'COMMISSION',
} as const;

export type InstallationReportTab =
  (typeof InstallationReportTab)[keyof typeof InstallationReportTab];
